module.exports = __webpack_public_path__ + "static/media/audio_new_gif.cd31256a.gif";